const descList = [
  '补两集《小猪佩奇》学学英语吧！',
  '哇，三年级的表弟不愁没人检查英语作业啦！',
  '给隔壁男生写英文情书， 他准挑不出毛病 ',
  '高考就是洒洒水，英语不再拖后腿！',
  '除非涂错答题卡，四级再挂就是傻！',
  '轻松考过425，从此六级不再苦。',
  '只要阴沟不翻船，7.5分考鸭游上岸。',
  '阅读写作不碍事，托福斩获幺幺四。',
  '昔有万元户，今有“万词王”。',
  '你简直是本会直立行走的词典！',
  '有道词神，独孤求败。',
]
const ua = navigator.userAgent
export const isYouDao = ua.indexOf('youdao')
export const isRecite = ua.indexOf('reciteword')
export const ydk = window.ydk
function share(str, silence) {
  if (isRecite == -1 || silence) {
    ydk.share({
      title: str,
      desc: "词汇量知根知底，遇考试百战百捷。你敢测测吗？",
      link: `http://shared.youdao.com/dict/market/recite-vocabulary/libs/index.html?a=1`,
      imgUrl: "http://shared.youdao.com/dict/market/recite-vocabulary/imgs/share.jpg",
      silence: silence,
      shift: true,
    })
  } else {
    window.location.href = `https://reciteword.youdao.com/shareAction?title=${str}&content=${'词汇量知根知底，遇考试百战百捷。你敢测测吗？'}&shareUrl=${window.location.href}`
  }
}

function registerShareData(shareData) {
  ydk._on('getShareData', {}, {
    complete: function (res) {
      res.responseCallback({
        code: 1000,
        errMsg: '',
        data: shareData
      })
    }
  });
};
export const setShare = (str,silence) => {
  let shareData = {
    'type': "",
    'title': str,
    'desc': "词汇量知根知底，遇考试百战百捷。你敢测测吗？",
    'silence': false,
    'link': "http://shared.youdao.com/dict/market/recite-vocabulary/libs/index.html?a=1",
    'imgUrl': "http://shared.youdao.com/dict/market/recite-vocabulary/imgs/share.jpg"
  }
  ydk.getClientInfo({
    success: function (res) {
      console.log(res);
      if (res.productName == "Trans") {
        registerShareData(shareData);
      } else {
        share(str, silence);
      }
    }
  });
  
}
// 去登录
export const login = () => {
  ydk.isLogin({
    success: function (res) {
      if (!res.isLogin) {
        if (isYouDao == -1) {
          window.location.href = 'https://c.youdao.com/dict/commons/login.html?back_url=' + encodeURIComponent(window.location.href)
        } else {
          ydk.login({
            defer: 3000
          })
        }
      }
    }
  })
}
// 选择生成图片的描述
export const choiceDesc = (num) => {
  let desc
  if (num < 1000) {
    desc = descList[0]
  } else if (num < 2000) {
    desc = descList[1]
  } else if (num < 3000) {
    desc = descList[2]
  } else if (num < 4000) {
    desc = descList[3]
  } else if (num < 5500) {
    desc = descList[4]
  } else if (num < 6500) {
    desc = descList[5]
  } else if (num < 8500) {
    desc = descList[6]
  } else if (num < 10000) {
    desc = descList[7]
  } else if (num < 13000) {
    desc = descList[8]
  } else if (num < 15000) {
    desc = descList[9]
  } else {
    desc = descList[10]
  }
  return desc
}

export const getQueryString = (name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/libs/libs.js